export const BEGINNING_OF_TIME_LABEL = "Beginning of time";
export const END_OF_TIME_LABEL = "End of time";
export const BEGINNING_OF_TIME_VALUE = "0";
export const END_OF_TIME_VALUE = "-1";
